import { PiwikClass } from '../../class/piwik.class'

export default {
  mounted () {
    const piwikClass = new PiwikClass(this.$VUE_MATOMO_EVENTS_CONFIG)
    piwikClass.init(this.$refs.main)
  }
}
